import { InputNumber, InputSlider, styled, Shape } from '@teko/ds-desktop';
import { SizeEnum } from '@teko/types/ds';
import React, { useMemo } from 'react';
import { t } from '../../i18n.es.js';
import { useDevice } from '../../contexts/DeviceContext.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const PriceFilterSGC = (_a) => {
  var _b = _a, {
    value,
    step = 1,
    onChange,
    onFilter,
    max,
    min
  } = _b, props = __objRest(_b, [
    "value",
    "step",
    "onChange",
    "onFilter",
    "max",
    "min"
  ]);
  const margin = useMemo(() => {
    const newMargin = __spreadValues({}, value);
    if ((value == null ? void 0 : value.lte) === void 0 || (value == null ? void 0 : value.lte) >= max)
      newMargin.lte = max;
    if ((value == null ? void 0 : value.gte) === void 0 || (value == null ? void 0 : value.gte) <= min)
      newMargin.gte = min;
    return newMargin;
  }, [max, min, JSON.stringify(value)]);
  const { isMobile } = useDevice();
  const commit = () => onFilter == null ? void 0 : onFilter(margin.gte, margin.lte);
  return /* @__PURE__ */ React.createElement(SliderShape, __spreadValues({}, props), /* @__PURE__ */ React.createElement(InputRow, null, /* @__PURE__ */ React.createElement(InputCell, null, /* @__PURE__ */ React.createElement(InputNumber, {
    bordered: true,
    min,
    max,
    placeholder: t("T\u1EEB"),
    addonAfter: /* @__PURE__ */ React.createElement(CurrencyUnit, null, "\u0111"),
    value: margin.gte,
    onChange: (v) => onChange == null ? void 0 : onChange(Number(v != null ? v : min), margin.lte),
    onBlur: commit,
    onPressEnter: commit
  })), /* @__PURE__ */ React.createElement(InputCell, null, /* @__PURE__ */ React.createElement(InputNumber, {
    bordered: true,
    min,
    max,
    placeholder: t("\u0110\u1EBFn"),
    addonAfter: /* @__PURE__ */ React.createElement(CurrencyUnit, null, "\u0111"),
    value: margin.lte,
    onChange: (v) => onChange == null ? void 0 : onChange(margin.gte, Number(v != null ? v : max)),
    onBlur: commit,
    onPressEnter: commit
  }))), /* @__PURE__ */ React.createElement(InputSlider, {
    range: true,
    size: isMobile ? SizeEnum.xl : SizeEnum.xs,
    thumbSize: 14,
    min,
    max,
    step,
    value: [margin.gte, margin.lte],
    onChange: ([gte, lte]) => {
      const next = {
        lte: Math.min(lte, max),
        gte: Math.max(gte, min)
      };
      onChange == null ? void 0 : onChange(next.gte, next.lte);
      onFilter == null ? void 0 : onFilter(next.gte, next.lte);
    },
    changeOn: "dragend"
  }));
};
PriceFilterSGC.displayName = "PriceFilterSGC";
const SliderShape = styled(Shape)`
  .slider-track {
    height: 4px;
  }
  .slider-thumb {
    box-shadow: none !important;
    border: 2px solid ${({ theme }) => theme.colors.primary};
  }
`;
const InputRow = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
`;
const InputCell = styled.div`
  flex: 1;

  .wrap-input-number {
    width: 100%;
    height: 40px;
    border-radius: ${({ theme }) => theme.borderRadius.m};
  }
`;
const CurrencyUnit = styled.span`
  color: ${({ theme }) => theme.colors.placeholder};
`;

export { PriceFilterSGC };
